var _excluded = ["iconProps", "onChange", "value", "maxValue", "disabledColor", "disabled", "allowHalfValues"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Div } from '@kizi/core-components';
import React, { useState } from 'react';
import { IconV2 } from './IconV2';

var isHalfValue = function isHalfValue(e) {
  var svg = e.target.getBoundingClientRect();
  var x = e.clientX - svg.left;
  return x < svg.width / 2;
};

export var getIconJsx = function getIconJsx(i, iconProps, valueToCheck, allowHalfValues, disabledColor) {
  if (i < valueToCheck) {
    var isLastIcon = i === Math.floor(valueToCheck);

    if (!isLastIcon) {
      // full colored icon
      return /*#__PURE__*/React.createElement(IconV2, _extends({
        key: 'icon-' + i
      }, iconProps, {
        name: "".concat(iconProps.name, "-full")
      }));
    } else {
      if (allowHalfValues && !Number.isInteger(valueToCheck)) {
        //half-colored icon
        return /*#__PURE__*/React.createElement(IconV2, _extends({}, iconProps, {
          key: 'icon-' + i,
          name: "".concat(iconProps.name, "-half")
        }));
      } else {
        return /*#__PURE__*/React.createElement(IconV2, _extends({
          key: 'icon-' + i
        }, iconProps, {
          name: "".concat(iconProps.name, "-empty")
        }));
      }
    }
  } else {
    // greyed out icon
    return /*#__PURE__*/React.createElement(IconV2, _extends({
      key: 'icon-' + i
    }, _objectSpread(_objectSpread({}, iconProps), {}, {
      fill: disabledColor
    }), {
      name: "".concat(iconProps.name, "-empty")
    }));
  }
};
export var Rating = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconProps = _ref.iconProps,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 5 : _ref$maxValue,
      _ref$disabledColor = _ref.disabledColor,
      disabledColor = _ref$disabledColor === void 0 ? 'grey' : _ref$disabledColor,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$allowHalfValues = _ref.allowHalfValues,
      allowHalfValues = _ref$allowHalfValues === void 0 ? true : _ref$allowHalfValues,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      _value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      highlightedIcons = _useState4[0],
      setHighlightedIcons = _useState4[1];

  var onMouseMove = iconProps.onMouseMove,
      onMouseLeave = iconProps.onMouseLeave,
      onClick = iconProps.onClick;
  var jsx = [];

  var updateValue = function updateValue(i, e) {
    return i + (isHalfValue(e) && allowHalfValues ? 0.5 : 1);
  };

  var valueToCheck = highlightedIcons > 0 ? highlightedIcons : _value;

  var setMarginRigh = function setMarginRigh(i, _maxValue) {
    return i === _maxValue - 1 ? 0 : 1;
  };

  var triggerEvent = function triggerEvent(eventHandler, e) {
    if (eventHandler) return eventHandler(e);
  };

  var _loop = function _loop(i) {
    var mr = setMarginRigh(i, maxValue);

    var _iconProps = _objectSpread({
      mr: mr
    }, iconProps);

    if (!disabled) {
      _iconProps.cursor = 'pointer';

      _iconProps.onClick = function (e) {
        var newValue = updateValue(i, e);
        setValue(newValue);
        if (onChange) onChange(newValue);
        triggerEvent(onClick, e);
      };

      _iconProps.onMouseMove = function (e) {
        var tempValue = updateValue(i, e);
        setHighlightedIcons(tempValue);
        triggerEvent(onMouseMove, e);
      };

      _iconProps.onMouseLeave = function (e) {
        setHighlightedIcons(0);
        triggerEvent(onMouseLeave, e);
      };
    }

    jsx.push(getIconJsx(i, _iconProps, valueToCheck, allowHalfValues, disabledColor));
  };

  for (var i = 0; i < maxValue; i++) {
    _loop(i);
  }

  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    ref: ref
  }, divProps), jsx);
});